import { DEFAULT_VARIANT, Icon } from "../Icon.js";
import { jsx } from "react/jsx-runtime";
import { useTranslation } from "react-i18next";

//#region src/components/icon/variants/IconLocationOn.tsx
const OutlinedFilledLocationOn = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M480.26-483q32.74 0 55.24-22.26 22.5-22.25 22.5-55 0-32.74-22.46-55.24-22.47-22.5-55.5-22.5Q447-638 425-615.54q-22 22.47-22 55.5Q403-527 425.26-505q22.25 22 55 22ZM480-55Q307-199 221-318.5T135-555q0-159.72 104.04-255.36Q343.08-906 480-906q136.49 0 241.25 95.64Q826-714.72 826-555q0 117-86.5 236.5T480-55Z" })
});
const OutlinedLocationOn = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M480.26-483q32.74 0 55.24-22.26 22.5-22.25 22.5-55 0-32.74-22.46-55.24-22.47-22.5-55.5-22.5Q447-638 425-615.54q-22 22.47-22 55.5Q403-527 425.26-505q22.25 22 55 22ZM480-179q128-115 189.5-204T731-555q0-112.52-72.64-184.26T480.15-811q-105.57 0-178.36 71.74Q229-667.52 229-555q0 83 63 171.5T480-179Zm0 124Q307-199 221-318.5T135-555q0-159.72 104.04-255.36Q343.08-906 480-906q136.49 0 241.25 95.64Q826-714.72 826-555q0 117-86.5 236.5T480-55Zm0-505Z" })
});
const RoundedFilledLocationOn = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M479.51-79q-12.51 0-26.1-4.5Q439.82-88 430-97q-48-40-100-90.5t-95.5-109Q191-355 163-420.5T135-555q0-159.72 104.25-255.36Q343.51-906 480-906t241.25 95.64Q826-714.72 826-555q0 69-28.5 134.5t-72 124Q682-238 630-187.5T531-97q-10.96 9-24.97 13.5-14.01 4.5-26.52 4.5Zm.58-404q32.91 0 55.41-22.09t22.5-55q0-32.91-22.59-55.41t-55.5-22.5Q447-638 425-615.41t-22 55.5Q403-527 425.09-505t55 22Z" })
});
const RoundedLocationOn = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M480-179q128-115 189.5-204T731-555q0-112.76-72.83-184.38Q585.35-811 479.96-811q-105.38 0-178.17 71.62Q229-667.76 229-555q0 83 63 171.5T480-179Zm-.49 100q-12.51 0-26.1-4.5Q439.82-88 430-97q-48-40-100-90.5t-95.5-109Q191-355 163-420.5T135-555q0-159.72 104.25-255.36Q343.51-906 480-906t241.25 95.64Q826-714.72 826-555q0 69-28.5 134.5t-72 124Q682-238 630-187.5T531-97q-10.96 9-24.97 13.5-14.01 4.5-26.52 4.5Zm.49-481Zm.09 77q32.91 0 55.41-22.09t22.5-55q0-32.91-22.59-55.41t-55.5-22.5Q447-638 425-615.41t-22 55.5Q403-527 425.09-505t55 22Z" })
});
const SharpFilledLocationOn = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M480.26-483q32.74 0 55.24-22.26 22.5-22.25 22.5-55 0-32.74-22.46-55.24-22.47-22.5-55.5-22.5Q447-638 425-615.54q-22 22.47-22 55.5Q403-527 425.26-505q22.25 22 55 22ZM480-55Q307-199 221-318.5T135-555q0-159.72 104.04-255.36Q343.08-906 480-906q136.49 0 241.25 95.64Q826-714.72 826-555q0 117-86.5 236.5T480-55Z" })
});
const SharpLocationOn = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M480.26-483q32.74 0 55.24-22.26 22.5-22.25 22.5-55 0-32.74-22.46-55.24-22.47-22.5-55.5-22.5Q447-638 425-615.54q-22 22.47-22 55.5Q403-527 425.26-505q22.25 22 55 22ZM480-179q128-115 189.5-204T731-555q0-112.52-72.64-184.26T480.15-811q-105.57 0-178.36 71.74Q229-667.52 229-555q0 83 63 171.5T480-179Zm0 124Q307-199 221-318.5T135-555q0-159.72 104.04-255.36Q343.08-906 480-906q136.49 0 241.25 95.64Q826-714.72 826-555q0 117-86.5 236.5T480-55Zm0-505Z" })
});
const componentMap = {
	outlined: OutlinedLocationOn,
	"outlined-fill": OutlinedFilledLocationOn,
	rounded: RoundedLocationOn,
	"rounded-fill": RoundedFilledLocationOn,
	sharp: SharpLocationOn,
	"sharp-fill": SharpFilledLocationOn
};
const IconLocationOn = ({ color, filled, height, variant = "rounded", style = {}, width, "data-testid": testId }) => {
	const { t } = useTranslation("pds");
	return /* @__PURE__ */ jsx(Icon, {
		SvgIcon: componentMap[`${variant}${filled ? "-fill" : ""}`] ?? componentMap[DEFAULT_VARIANT],
		alt: t(""),
		"data-testid": testId,
		color,
		style,
		height,
		width
	});
};

//#endregion
export { IconLocationOn };